import React, { useState } from "react";

import { FaRegCalendarAlt } from "react-icons/fa";
import {
  MdKeyboardArrowRight,
  MdKeyboardArrowDown,
  MdOutlineCancel,
  MdOutlineArrowDropUp,
} from "react-icons/md";
import Input from "../UIResuableComponents/CreateForm/Input";
import Button from "../UIResuableComponents/Button";
function ChartBase(props) {
  const [fromToDate, setFromToDate] = useState({
    from: "",
    to: "",
  });
  const [dateToggle, setDateToggle] = useState(false);
  const onInputChangeHandler = (name, value) => {
    const newData = { ...fromToDate };
    newData[name] = value;
    setFromToDate(newData);
  };
  const onClickDateToggle = (e, type) => {
    e.preventDefault();

    setDateToggle(type);
  };

  return (
    <div className="bg-bgwhite  rounded mb-3  py-5 px-2">
      <div className="flex flex-col lg:flex-row justify-between items-start w-full border-b-[1px] border-bglightgrey p-2 text-center sm:text-left items-center sm:items-start">
        <div className="mb-2 w-full mr-6">
          <h3 className="text-xs">{props.chartName}</h3>
          <p className="text-[0.6rem] text-lightgrey">{props.subheading}</p>
        </div>
        <div className="mr-4">
          <Button
            onClickHandler={props.openComparePopUpToggle}
            btnName="Compare"
            btnStyle={`bg-btnbgcolor text-bgwhite !py-1 !px-2 !text-xs font-bold `}
            openComparePopUpToggle={props.openComparePopUpToggle}
          />
        </div>
        <div className="relative cursor-pointer text-btnbgcolor text-[0.5rem] report-date-shadow rounded ">
          <div
            onClick={(e) => onClickDateToggle(e, true)}
            className="flex justify-center items-center py-1 px-2"
          >
            {" "}
            <span className="mr-2">
              <FaRegCalendarAlt />
            </span>
            <span>19.12.2020-</span>
            <span>03.12.2021</span>
            <span className="text-base">
              <MdKeyboardArrowDown />
            </span>
          </div>
          {dateToggle && (
            <div className="absolute top-[130%] p-3 bg-bgdarkgrey rounded">
              <div
                onClick={(e) => onClickDateToggle(e, false)}
                className="absolute top-[3%] right-[5%] text-base"
              >
                <MdOutlineCancel />
              </div>
              <Input
                valueLabel={"from"}
                onInputChangeHandler={onInputChangeHandler}
                type={"text"}
                Name={"From"}
                value={fromToDate.from}
                inputStyle={"!py-[0.1rem]"}
                labelStyle={"!text-xs"}
                isRequired={false}
              />
              <Input
                valueLabel={"to"}
                onInputChangeHandler={onInputChangeHandler}
                type={"text"}
                Name={"To"}
                value={fromToDate.to}
                inputStyle={"!py-[0.1rem]"}
                labelStyle={"!text-xs"}
                isRequired={false}
              />
            </div>
          )}
        </div>
      </div>

      <div className="w-full px-1">{props.children}</div>
      {props.seeDetail && (
        <div className="flex flex-col justify-between items-start w-full border-t-[1px] border-bglightgrey p-2 mt-2">
          <div className="mb-2 w-full text-right font-medium">
            <h3 className="text-sm flex justify-end items-center">
              SEE DETAILS
              <span className="text-xl">
                <MdKeyboardArrowRight />
              </span>
            </h3>
          </div>
        </div>
      )}
      {props.extraInfo && (
        <div>
          <span>5000</span>
          <div>
            Total Production
            <span>
              <MdOutlineArrowDropUp />
              +2.45%
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
export default ChartBase;
